module.exports = __webpack_public_path__ + "img/poster.8639a8cd.jpg";